import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=b9e1b5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e1b5a6"]])

export default __exports__